<template>
  <tr v-if="item.type === 0 ">
    <td class="group_res" >
      {{ name }}({{ item.online }} / {{ item.count }})
    </td>
  </tr>
  <tr v-else-if="item.type === -1">
    <td class="group_res">
      {{ translate('no_result') }}
    </td>
  </tr>
  <router-link v-else :to="go_to()" class="simcard_profile">
    <tr class="link" >
      <td :data-label="translate('simcard_profile.status')" :title="sim_state_title(item.sim_state)" style="width: 100px">
        <div v-if="item.sim_state && Object.keys(item.sim_state).length" class="sim-state">
          <SimState :sim_state="item.sim_state" />
          <SignalQualityIndicator :data="item.sim_state" />
        </div>
      </td>
      <td class="w5per" :data-label="translate('simcard_profile.mno')">
        {{ item.mno }}
      </td>

      <td :data-label="translate('simcard_profile.oper_account')">
        {{ item.oper_account }}
      </td>

      <td :data-label="translate('simcard_profile.number')">
        {{ item.msisdn }}
        <span v-if="item.msisdn" class="mdi mdi-content-copy" @click.stop.prevent="copy(item.msisdn)" />
      </td>

      <td :data-label="translate('simcard_profile.imsi')">
        {{ item.imsi }}
        <span v-if="item.imsi" class="mdi mdi-content-copy" @click.stop.prevent="copy(item.imsi)" />
      </td>

      <td class="w10per" :data-label="translate('simcard_profile.iccid')">
        <router-link :to="{path: '/device_list?&universal_search=' + item.iccid}" @click.stop.prevent="">
          {{ item.iccid }}
        </router-link>
        <span v-if="item.iccid" class="mdi mdi-content-copy" @click.stop.prevent="copy(item.iccid)" />
      </td>

      <td :data-label="translate('simcard_profile.tariff')" style="width: 300px">
        {{ simcard_tariff(item.tariff_id) }}
      </td>

      <td :data-label="translate('tariffication.device')" style="width: 160px" @click.stop="">
        <template v-if="item.device_fid">
          <router-link :to="{path: '/device/' + item.device_fid}">{{ item.device_fid }}</router-link>
          <div>{{ item.device_name }}</div>
          <div v-if="item.device_ts_sync">{{ get_date(item.device_ts_sync) }}</div>
        </template>
      </td>

      <td :data-label="translate('simcard_profile.type_short')" class="w70">
        {{ simcard_esim(item.sim_type) }}
      </td>

      <td :data-label="translate('simcard_profile.apn_short')" style="width: 120px">
        {{ simcard_apn(item.simcard_operator_apn_id) }}
      </td>

      <td :data-label="translate('simcard_profile.status')" style="width: 120px">
        <span class="badge" :class="global_status_color(+item.status)">
            {{ translate(global_status_text(+item.status)) }}
        </span>
      </td>

      <td :data-label="translate('simcard_profile.ts_update')" v-html="get_date_any_lines(item.ts_update, null, 2)"></td>
    </tr>
  </router-link>

</template>
<script>
import SimState from "components/UIComponents/SimState/Index.vue";
import SignalQualityIndicator from "components/UIComponents/SignalQualityIndicator/SignalQualityIndicator.vue";

export default {
  name: 'SimCardProfileListItem',
  components: {
    SimState,
    SignalQualityIndicator
  },
  props: ['item', 'index', 'checked', 'checkbox', 'groups', 'traffic_list'],
  data () {
    return {
      status: false,
      chartStatus: false,
      resize: false
    }
  },
  computed: {
    name () {
      if (this.item.type === 0) {
        return this.$store.getters.getSimcardDevicesGroupById(this.item.id).name
      }
      else {
        let name = this.item.name2
        if (this.$store.getters.getPermissions.permissionGod) {
          name += ' / '
          name += this.item.name
        }
        return name
      }
    },
  },
  activated () {
    this.$emit('mount', this.index)
  },
  mounted () {
    this.$emit('mount', this.index)
  },
  methods: {
    copy(string){
      this.copy_to_clipboard(string)
      this.global_notify("info", this.translate("clipboard.value_save_buffer"));
    },
    simcard_esim(type){
      switch (type) {
        case 0: return 'sim'
        case 1: return 'esim'
      }
    },
    simcard_tariff(id){
      return this.traffic_list[id] ? this.traffic_list[id].tariff_name : ''
    },
    simcard_apn(selected_apn_id){
      const simcard_apn = this.$store.getters.getSimcardOperatorApn.find((apn) => {
        if (selected_apn_id === apn.id) return apn
      })
      return simcard_apn ? simcard_apn.title : ""
    },
    check () {
      this.$emit('check', !this.item.checked, this.item.device_id)
    },
    cntx_menu (e) {
      this.$emit('contextmenu', e, this.item)
    },
    go_to () {
      let id = this.item.imsi && String(this.item.imsi).length > 14 ? this.item.imsi : this.item.id
      return {path: '/simcard_profile/' + id}
    },
    ready () {
      this.$emit('ready', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .error_device {
    font-size: 20px;
    color: #FF0000;
  }
  .group_res{
    cursor: auto;
  }
  .simcard_profile{
    .sim-state{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    tr{
      &:hover{
        background-color: #eeeeee;
      }
    }
  }
</style>
